(ns shared.core.utils.currency
  (:require [clojure.string :as s]
            [goog.string :as gstring]
            [shared.core.config :as config]))

(def country-code->international-currency-details
  {"CA" {:locale "en-CA"
         :currency "CAD"}
   "GB" {:locale "en-GB"
         :currency "GBP"}
   "US" {:locale "en-US"
         :currency "USD"}})

(defn- replace-all
  [s re replacement]
  (let [r (js/RegExp. (.-source re)
                      (cond-> "g"
                              (.-ignoreCase re) (str "i")
                              (.-multiline re) (str "m")
                              (.-unicode re) (str "u")))]
    (.replace s r replacement)))

(defn to-precision [num & {:keys [precision] :or {precision 2}}]
  (gstring/format (str "%." precision "f") num))

(defn readable-number [n]
  (let [has-decimal? (s/includes? (str n) ".")
        num-str (if has-decimal? (to-precision (js/parseFloat (str n))) (str n))
        [int-part dec-part] (s/split num-str #"\." 2)
        grouped (replace-all int-part #"\B(?=(\d{3})+(?!\d))" ",")]
    (if dec-part
      (str grouped "." dec-part)
      grouped)))

(defn pennies->readable-price-us [pennies]
  (str "$" (readable-number (s/replace (str (to-precision (/ pennies 100))) "$" ""))))

(defn currency-integer->readable-currency [country-code currency-int]
  (try
    (let [{:keys [locale currency]} (get country-code->international-currency-details country-code)]
      (if (and locale currency)
        (let [currency-formatter (js/Intl.NumberFormat locale (clj->js {:style "currency" :currency currency}))]
          (.format currency-formatter (to-precision (/ currency-int 100))))
        (pennies->readable-price-us currency-int)))
    (catch :default _
      (pennies->readable-price-us currency-int))))

(defn currency-int->readable-price [currency-int]
  (if @config/country-code*
    (currency-integer->readable-currency @config/country-code* currency-int)
    (pennies->readable-price-us currency-int)))

(defn get-currency-symbol []
  (try
    (let [{:keys [locale currency]} (get country-code->international-currency-details (or @config/country-code* "US"))]
      (-> (.toLocaleString 0
                           locale
                           #js {:style "currency"
                                :currency currency
                                :minimumFractionDigits 0
                                :maximumFractionDigits 0})
          (.replace (js/RegExp. "\\d" "g") "")
          (.trim)))
    (catch :default _
      "$")))
